export default () => ({
    init() {
        this.$el.addEventListener('click', (e) => {
            this.$store.cart.updateCart(e);
        })
    }
})